import { useEffect, useState } from 'react';

export const useScreenHeight = (): number => {
  const [screenHeight, setScreenHeight] = useState(0);

  useEffect(() => {
    setScreenHeight(window.innerHeight);
  }, []);

  return screenHeight;
};
